module.exports = __webpack_public_path__ + "img/news-image.94669e15.png";